var _rect, _circle, _circle2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSugarcane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 520",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Compostable sugarcane plates and containers") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 520,
    fill: "#edf3e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 280,
    r: 165,
    fill: "#fffdf7",
    stroke: "#162d45",
    strokeWidth: 14
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 280,
    r: 112,
    fill: "none",
    stroke: "#c8b98a",
    strokeWidth: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210 405c-52-72-38-159 38-220 14 89 4 165-38 220z",
    fill: "#7da061",
    stroke: "#162d45",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M208 405c22-82 53-143 94-184",
    fill: "none",
    stroke: "#162d45",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M177 300c-53-21-83-59-90-115 62 15 106 48 132 99",
    fill: "#9fba77",
    stroke: "#162d45",
    strokeWidth: 9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M586 125c44 18 78 48 102 91",
    stroke: "#c49356",
    strokeWidth: 14,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSugarcane);
export default __webpack_public_path__ + "static/media/sugarcane.b6489dc4e4dc89ffc1f4b2ab9dc02f30.svg";
export { ForwardRef as ReactComponent };